var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"24","height":"24","key":0}),React.createElement("polyline",{"stroke":"#084782","strokeLinecap":"round","strokeLinejoin":"round","points":"3 7 12 13 21 7","key":1}),React.createElement("rect",{"width":"19","height":"12","x":"2.5","y":"6","stroke":"#084782","strokeLinecap":"square","strokeLinejoin":"round","rx":"1","key":2})]));
}

Email.displayName = "Email";

Email.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Email;

Email.default = Email;



//////////////////
// WEBPACK FOOTER
// ./src/app/icons/email.svg
// module id = 291
// module chunks = 0